import React from 'react';
import { DialogUI } from '../Interface';
import SourceListPage from './SourceListPage';

const SourceListDialog = ({ showDialog, onClose, selectedItemCode, items }) => {
  return (
    <DialogUI
      open={showDialog}
      headerContent={'Forrásjegyzék'}
      fullWidth={true}
      onClose={onClose}
      closeBtn={true}
      maxWidth="xl"
    >
      <SourceListPage selectedItemCode={selectedItemCode} items={items} />
    </DialogUI>
  );
};

export default SourceListDialog;
